import { FetchError } from 'api/API';
import { A02, A02Output } from 'api/U001';
import { useCallback, useState } from 'react';

type UpdateLastLoginDoRequest = (param: {
  onSuccess?: (response: A02Output) => void;
  onError?: (err: Error) => void;
  cancellation?: AbortSignal;
}) => Promise<void>;

export function useUpdateLastLogin(): [UpdateLastLoginDoRequest, boolean, Error | null] {
  const [loading, setLoading] = useState<boolean>(false);
  const [err, setError] = useState<Error | null>(null);

  const updateLastLogin = async (cancellation: AbortSignal) => {
    const json = await A02(cancellation);
    return json;
  };

  const doRequest = useCallback<UpdateLastLoginDoRequest>(
    async ({ cancellation, onSuccess, onError }) => {
      const controller = new AbortController();
      const cancelSignal = cancellation ?? controller.signal;
      try {
        const result = await updateLastLogin(cancelSignal);
        onSuccess?.(result);
      } catch (err) {
        console.error({ err });
        if (err instanceof FetchError) {
          const errorData = await err.response.json();
          const flooredError = new Error(errorData.message || `HTTP ERROR: ${err.message}`);
          onError?.(flooredError);
          setError(flooredError);
        } else {
          const flooredError = new Error(`unknown error. ${err}`);
          onError?.(flooredError);
          setError(flooredError);
        }
      } finally {
        setLoading(false);
      }
    },
    [updateLastLogin, setLoading, setError]
  );

  return [doRequest, loading, err];
}
